var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup256(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_256",
    "data-name": "Group 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.04,
    height: 30,
    viewBox: "0 0 30.04 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 30.04,
    height: 30,
    fill: "#d10a11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M0,12.286A12.3,12.3,0,0,1,24.309,9.637a11.852,11.852,0,0,1-1.484,8.957c-.1.159-.116.256.033.4,2.114,2.1,4.21,4.224,6.334,6.317a2.7,2.7,0,0,1-1,4.532,2.6,2.6,0,0,1-2.827-.727L20.1,23.856c-.346-.346-.7-.686-1.036-1.042a.266.266,0,0,0-.4-.053,11.414,11.414,0,0,1-4.545,1.651,12.077,12.077,0,0,1-7.733-1.4,11.952,11.952,0,0,1-6.054-8.2C.147,13.986.106,13.129,0,12.286m5.522,0a6.738,6.738,0,0,0,6.827,6.807,6.759,6.759,0,0,0,6.8-6.845,6.737,6.737,0,0,0-6.821-6.782,6.717,6.717,0,0,0-6.806,6.82",
    transform: "translate(0 0)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup256);
export default __webpack_public_path__ + "static/media/Group 256.299303381f86f622b14e27586f12fb14.svg";
export { ForwardRef as ReactComponent };